const SOCIAL_AUTH_ERROR_KEY = "social_auth_error";

export function consumeSocialAuthError() {
  try {
    const message = sessionStorage.getItem(SOCIAL_AUTH_ERROR_KEY);
    if (message) sessionStorage.removeItem(SOCIAL_AUTH_ERROR_KEY);
    return message;
  } catch {
    return null;
  }
}

export function storeSocialAuthError(message) {
  try {
    if (message) sessionStorage.setItem(SOCIAL_AUTH_ERROR_KEY, message);
  } catch {
    /* ignore */
  }
}
